import { useRef } from 'react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

import { store } from '../../lib/redux';
import * as actions from './store/actions';
import * as URL from '../../lib/router/url';
import { ERROR_INVALID_TOKEN, ERROR_ACCESS_DENIED } from './store/constants';
import { signInValidationSchema } from './validation';
import { Form, StringInput, PasswordInput, SubmitButton } from '../core/components/forms';
import useComponentDidMount from '../core/hooks/useComponentDidMount';

const signIn = async (values, form) => {
  try {
    await store.dispatch(actions.login(values));
  } catch (error) {
    form.setErrors(error);

    throw error;
  } finally {
    form.setSubmitting(false);
  }
};

// interface SignInProps {
//   error?: object
//   registrationInfo?: object
// }

const SignIn = (props) => {
  const { error, registrationInfo } = props;
  const formRef = useRef(null);
  const loginRef = useRef(null);
  const passwordRef = useRef(null);
  const errorAlert = (error
        && (error.message !== ERROR_INVALID_TOKEN)
        && (error.message !== ERROR_ACCESS_DENIED)
  ) ? (
      <Alert variant='danger'>{ error.message }</Alert>
    ) : null;

  const handleKeyPress = (event) => {
    if (event.which === 13) { // Enter
      passwordRef.current.focus();
    }
  };

  useComponentDidMount(() => {
    if (loginRef) { loginRef.current.focus(); }
  });

  const handleKeyPressSubmit = (event) => {
    if (event.which === 13) {
      if (typeof formRef.current?.submitForm === 'function') {
        formRef.current.submitForm();
      }
    }
  };

  return (
    <Form
      ref={ formRef }
      initialValues={ { username: registrationInfo.email ?? '', password: '' } }
      validationSchema={ signInValidationSchema }
      onSubmit={ signIn }
      enableReinitialize
    >
      { errorAlert }

      <Row>
        <Col lg={ 12 }>
          <StringInput name='username' label='Email' placeholder='Введите e-mail' ref={ loginRef } onKeyPress={ handleKeyPress } />
        </Col>
        <Col lg={ 12 }>
          <PasswordInput name='password' label='Пароль' placeholder='Введите пароль' ref={ passwordRef } onKeyPress={ handleKeyPressSubmit } />
        </Col>
      </Row>

      <Row>
        <Col lg={ 12 }>
          <ButtonGroup vertical>
            <SubmitButton text='Войти' />
          </ButtonGroup>

          <div className='text-center' style={ { marginTop: '15vh' } }>
            <Link className='text-center' to={ URL.URL_RESTOREPWD }>
              Забыли пароль?
            </Link>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    registrationInfo: state.auth?.registrationInfo,
    error: state.auth?.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: payload => dispatch(actions.login(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
